<template>
  <div class="marker" :class="'marker-' + type" @click="onClick">
    <img :src="markers[type]" alt="" />
  </div>
</template>

<script>
export default {
  name: "MapMarker",
  props: {
    type: String,
    detail: Object,
  },
  data() {
    return {
      markers: {
        D01: require("../images/pressure-marker.png"),
        D03: require("../images/flow-marker.png"),
        D04: require("../images/quality-marker.png"),
        factory: require("../images/factory-marker.png"),
        pump: require("../images/pump-marker.png"),
        dma: require("../images/dma-marker.png"),
        flowmeter: require("../images/flow-marker.png"),
      },
    };
  },
  methods: {
    onClick() {
      this.$emit("modal", this.detail);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.marker {
  cursor: pointer;
  width: 30px;
  height: 70px;

  img {
    width: 30px;
    height: 70px;
  }
}
</style>
